import * as React from "react";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setActiveHoverImage } from "../../store/tableSlice";

const HoverImage = ({ src, alt, rowId, columnId }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dispatch = useDispatch();

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const previewWidth = 256; // 16 * 16 = 256px (w-64)

    // Calculate if there's enough space to the right
    const spaceToRight = viewportWidth - rect.right;
    const spaceToLeft = rect.left;

    let xPosition;

    if (spaceToRight >= previewWidth + 10) {
      // Show to the right if there's enough space
      xPosition = rect.right + 10;
    } else if (spaceToLeft >= previewWidth + 10) {
      // Show to the left if there's enough space
      xPosition = rect.left - previewWidth - 10;
    } else {
      // Center it if there's not enough space on either side
      xPosition = Math.max(
        10,
        Math.min(
          viewportWidth - previewWidth - 10,
          rect.left - (previewWidth - rect.width) / 2
        )
      );
    }

    // Calculate vertical position
    const viewportHeight = window.innerHeight;
    const previewHeight = 256;
    let yPosition = rect.top;

    // Adjust if preview would go below viewport
    if (rect.top + previewHeight > viewportHeight) {
      yPosition = Math.max(10, viewportHeight - previewHeight - 10);
    }

    setPosition({
      x: xPosition,
      y: yPosition,
    });
    setShowPreview(true);
    dispatch(setActiveHoverImage({ rowId, columnId }));
  };

  const handleMouseLeave = () => {
    setShowPreview(false);
    dispatch(setActiveHoverImage(null));
  };

  return (
    <div className="relative">
      <img
        src={src}
        alt={alt}
        className="h-16 w-16 object-cover cursor-pointer"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />

      {showPreview && (
        <div
          className="fixed"
          style={{ left: position.x, top: position.y }}
          onMouseLeave={handleMouseLeave}
        >
          <div className="animate-in zoom-in duration-300">
            <img
              src={src}
              alt={alt}
              className="w-64 h-64 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default HoverImage;
